// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7163":"4f7036fa","8840":"eec034a2"}[chunkId] + ".chunk.css";
};